import { render } from "./WrapWithHighlight.vue?vue&type=template&id=489590ff&scoped=true"
import script from "./WrapWithHighlight.vue?vue&type=script&lang=js"
export * from "./WrapWithHighlight.vue?vue&type=script&lang=js"

import "./WrapWithHighlight.vue?vue&type=style&index=0&id=489590ff&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489590ff"]])

export default __exports__